import { render, staticRenderFns } from "./NuevoUbicacion.vue?vue&type=template&id=0ef623d4&scoped=true"
import script from "./NuevoUbicacion.vue?vue&type=script&lang=js"
export * from "./NuevoUbicacion.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NuevoUbicacion.vue?vue&type=style&index=1&id=0ef623d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef623d4",
  null
  
)

export default component.exports